export function getUtcDayName(date, lang = 'cs') {
    const dayTable = {
        cs: {
            1: 'Pondělí',
            2: 'Úterý',
            3: 'Středa',
            4: 'Čtvrtek',
            5: 'Pátek',
            6: 'Sobota',
            0: 'Neděle',
        },
        en: {
            1: 'Monday',
            2: 'Tuesday',
            3: 'Wednesday',
            4: 'Thursday',
            5: 'Friday',
            6: 'Saturday',
            0: 'Sunday',
        },
    };
    if (date instanceof Date) {
        const day = date.getUTCDay();
        return dayTable[lang][day];
    }
    return null;
}
/**
 * Currently is used only in reservation module.
 * @param value
 * @param displayDayName // Currently is used only in DateTimeSelector
 * @param lang // Relevant if displayDayName is true
 * @returns string 'DD.MM.YYYY' or 'DD.MM.YYYY, dayName'
 */
export function formatDate(value, displayDayName = false, lang = 'cs') {
    if (typeof value !== 'string')
        return null;
    const date = new Date(value);
    let month = String(date.getUTCMonth() + 1);
    let day = String(date.getUTCDate());
    const year = String(date.getUTCFullYear());
    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;
    if (displayDayName) {
        const dayName = getUtcDayName(date, lang);
        if (dayName) {
            return [day, month, year].join('.') + ', ' + dayName;
        }
    }
    return [day, month, year].join('.');
}
export function ymdToDmy(value) {
    const regEx = /^\d{4}-\d{2}-\d{2}$/;
    if (!value.match(regEx))
        return null;
    const [year, month, day] = value.split('-');
    return `${day}.${month}.${year}`;
}
